<!-- js/components/Shared/VueCond.vue -->

<template>
    <span>{{ (value == null || value.length <= 0) ? ifEmpty : value }}</span>
</template>

<script>

export default {
    
    props: {
        value: null,
        ifEmpty: {
            default: "-"
        }
    }
}
</script>